import React, { FormEvent, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import './styles/SignOn.scss'

import { authenticate } from 'panel/user/redux/actions'

const SignIn: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  const [isFetching, setFetching] = useState(false)
  const [form, setForm] = useState({ username: '', password: '' })
  const [showPassword, setShowPassword] = useState(false)

  async function handleForm (e: FormEvent): Promise<void> {
    e.preventDefault()
    setFetching(true)
    await authenticate(form)(dispatch).then(res => {
      if (res?.status === 'success' && res?.data?.token) {
        history.push('/panel')
      }
    })
    setFetching(false)
  }

  const logo = `${process.env.PUBLIC_URL}/img/logo.png`
  const logoWhite = `${process.env.PUBLIC_URL}/img/logo-white.png`

  return (
    <div className="row sign-on">
      <div className="row">
        <div className="row side-left hidden-mobile">
          <img className="margin-top-16" src={logoWhite} alt="Logo" />
        </div>
        <form onSubmit={handleForm} className="row side-right">
          <img className="padding-16 margin-tb-16 logo-img hidden-desk" src={logo} alt="Logo" />
          <h1 style={{ fontSize: 20 }} className="text-center">Faça login para acessar o painel</h1>
          <p className="text-center"><i className="fa fa-shield-alt"/>Ambiente Seguro</p>

          {/* Inputs */}
          <div className="form-control margin-top-32">
            <label>E-mail</label>
            <input
              type="text"
              value={form.username}
              onChange={(e): void => setForm({ ...form, username: e.target.value })}
              required={true}
            />
          </div>
          <div className="form-control">
            <label>Senha</label>
            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={(e): void => setForm({ ...form, password: e.target.value })}
                required={true}
              />
              <i
                className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} password-toggle`}
                onClick={(): void => setShowPassword(!showPassword)}
                title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
              />
            </div>
            <NavLink to="/recovery" className="recovery">Esqueceu sua senha?</NavLink>
          </div>

          {/* Buttons */}
          <div className="form-control margin-top-16">
            <button className="button primary col-12" disabled={isFetching}>
              { isFetching ? 'Fazendo login. Aguarde...' : 'Entrar' }
            </button>

            <NavLink to="/sign-up" className="button secondary col-12 margin-top-8">
              Cadastre-se
            </NavLink>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SignIn
